// extracted by mini-css-extract-plugin
module.exports = {"label":"label__1Nk1v","left":"left__2xUIM","center":"center__OZdH7","right":"right__3czPr","hidden":"hidden__aMVHa"};